import React from "react";
import CardBox from "../../common/CardBox";
import { Button, Card, Col, Collapse, CollapseProps, Row } from "antd";
import { Link } from "react-router-dom";
import { CloseOutlined, RollbackOutlined } from "@ant-design/icons";
import CustomerDetails from "./customer-details";
import TourDetails from "./tour-details";

const items: CollapseProps["items"] = [
  {
    key: "1",
    label: "Customer Details",
    children: <CustomerDetails />,
  },
  {
    key: "2",
    label: "Tour Details",
    children: <TourDetails />,
  },
];

export const CreateBooking = () => {
  return (
    <CardBox
      title={
        <div>
          <span>New Booking</span>
          <span className="highlightBorder"></span>
        </div>
      }
      extra={
        <Link to={"/home/booking"}>
          <Button
            type="primary"
            className="componentCloseIcon"
            icon={<CloseOutlined />}
            size="middle"
          />
        </Link>
      }
    >
      <Collapse
        className="booking-collapse"
        accordion={false}
        defaultActiveKey={[1, 2]}
        items={items}
      />
      <Row className="bottomButtonBox">
        <Col span={12} className="leftButtons">
          <Button color="default" variant="solid" htmlType="reset">
            <RollbackOutlined /> Back
          </Button>
        </Col>
        <Col span={12} className="rightButtons">
          <Button type="primary" htmlType="submit">
            Save as Draft
          </Button>
          <Button type="primary" htmlType="submit">
            Submit Booking
          </Button>
        </Col>
      </Row>
    </CardBox>
  );
};

export default CreateBooking;